// src/app/services/authorization.service.ts
import { Injectable } from '@angular/core';
import { AuthFirebaseService } from './auth-firebase.service';

@Injectable({
  providedIn: 'root',
})
export class AskRolService {
  constructor(private authFirebaseService: AuthFirebaseService) {}

  get userRole(): string {
    return this.authFirebaseService.adminData?.role || '';
  }

  get userScope(): string {
    return this.authFirebaseService.adminData?.scope || '';
  }

  get esSuperAdmin(): boolean {
    return this.userRole === 'ROOT' && this.userScope === 'ALL';
  }

  get esSuperAdminEntidad(): boolean {
    return this.userRole === 'ROOT' && this.userScope !== '' && this.userScope !== 'ALL';
  }

  get esAdminEntidad(): boolean {
    return this.userRole === 'ADMINISTRATOR';
  }

  get nombreEntidad(): string {
    return this.authFirebaseService.adminData?.entidad?.name || '';
  }

  get cifEntidad(): string {
    return this.authFirebaseService.adminData?.entidad?.cif || '';
  }

}
